import { useEffect } from "react";
import { CheckCircle2, XCircle, AlertCircle, Info, X } from "lucide-react";

/**
 * Modern Toast Notification Component
 * Replaces system alert() dialogs
 */
export default function Toast({ type = "info", message, onClose, duration = 4000 }) {
  useEffect(() => {
    if (duration > 0) {
      const timer = setTimeout(onClose, duration);
      return () => clearTimeout(timer);
    }
  }, [onClose, duration]);

  const styles = {
    success: {
      bg: "bg-emerald-50 border-emerald-200",
      text: "text-emerald-900",
      icon: <CheckCircle2 size={18} className="text-emerald-600" />,
    },
    error: {
      bg: "bg-red-50 border-red-200",
      text: "text-red-900",
      icon: <XCircle size={18} className="text-red-600" />,
    },
    warning: {
      bg: "bg-amber-50 border-amber-200",
      text: "text-amber-900",
      icon: <AlertCircle size={18} className="text-amber-600" />,
    },
    info: {
      bg: "bg-blue-50 border-blue-200",
      text: "text-blue-900",
      icon: <Info size={18} className="text-blue-600" />,
    },
  };

  const style = styles[type] || styles.info;

  return (
    <div
      className={`
        fixed bottom-6 left-1/2 -translate-x-1/2
        flex items-center gap-3
        ${style.bg} ${style.text}
        px-4 py-3
        rounded-lg
        border
        shadow-lg
        z-50
        text-sm
        min-w-[320px]
        max-w-md
        animate-slide-up
      `}
    >
      {style.icon}
      <span className="flex-1">{message}</span>
      <button
        onClick={onClose}
        className="p-0.5 hover:bg-black/5 rounded transition-colors"
        aria-label="Close"
      >
        <X size={16} />
      </button>
    </div>
  );
}
